import React from "react";
import { WarningOctagon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

/**
 * v0.4.8 — Period-mismatch banner. Shown when calc.period_mismatch is
 * true: transaction dates fall outside the declared period. Equivalent
 * severity to DO NOT FILE — block freeze, force a re-run.
 */
export const PeriodMismatchBanner = ({ calc }) => {
  const { t } = useTranslation();
  if (!calc?.period_mismatch) return null;
  const d = calc.period_mismatch_details || {};
  return (
    <div
      data-testid="period-mismatch-banner"
      className="bg-red-600 text-white border-l-4 border-red-300 rounded-xl"
    >
      <div className="px-4 py-3 flex items-start gap-3">
        <WarningOctagon size={22} weight="bold" className="shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="text-xs tracking-normal opacity-80">
            {t("ui.period_mismatch.eyebrow", { defaultValue: "PERIOD AUDIT" })}
          </div>
          <div
            data-testid="period-mismatch-banner-status"
            className="text-lg font-black tracking-widest"
          >
            {t("ui.period_mismatch.status", { defaultValue: "PERIOD_MISMATCH — REVIEW BEFORE RELYING ON THIS FILING" })}
          </div>
          <div className="text-xs mt-1 space-y-0.5 opacity-90">
            <div>
              {t("ui.period_mismatch.declared", { defaultValue: "DECLARED" })} <span className="font-bold">{d.declared_start}</span> →{" "}
              <span className="font-bold">{d.declared_end}</span>
            </div>
            <div>
              {t("ui.period_mismatch.actual", { defaultValue: "ACTUAL" })}{"   "}
              <span className="font-bold">{d.first_actual_date}</span> →{" "}
              <span className="font-bold">{d.last_actual_date}</span>
            </div>
            <div>
              {t("ui.period_mismatch.body", { outside: d.outside_count ?? "", total: d.total_count ?? "", defaultValue: `${d.outside_count ?? ""} of ${d.total_count ?? ""} transactions fall outside the declared period. Freeze is blocked. Re-run the calc with a period that contains every row, or split the run.` })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
